import { defineAsyncComponent, markRaw } from "vue";

export default function useShiftCoverRequestSequence(context, submitCallback) {
  const shiftCoverMustBeApproved = true; // @todo this can be a feature flag.
  /* v8 ignore start*/
  if (!context.shift) {
    throw new Error(
      "Shift context is required for Shift Cover Request Sequence.",
    );
  }
  /* v8 ignore end*/

  const formSequence = [
    {
      id: "coverReason",
      skipAnswerCleanup: true,
      component: markRaw(
        defineAsyncComponent(
          () => import("@/components/form/elements/ButtonGroup.vue"),
        ),
      ),
      props: {
        title: "What's the reason for requesting cover?",
        options: [
          {
            label: "Holiday / Leave",
            value: "holiday",
            icon: "umbrella-beach",
          },
          {
            label: "Sickness / Injury",
            value: "sick",
            icon: "temperature-high",
          },
          {
            label: "Other",
            value: "old",
          },
        ],
      },

      next: async () => ({ nextStepId: "end" }),
    },
    {
      id: "end",
      final: true,
      component: markRaw(
        defineAsyncComponent(
          () =>
            import("@/components/form/sequences/ShiftCoverRequestReview.vue"),
        ),
      ),
      props: {
        shiftCoverMustBeApproved,
        shift: context.shift,
        /* v8 ignore next 2 */
        activities: context.activities || [],
      },
      next: async (answer, answers, context) => {
        const result = await submit(context, answers);

        /* v8 ignore next 10 */
        if (result !== false) {
          return {
            nextStepId: null,
            success: true,
          };
        }
        return {
          nextStepId: null,
          success: false,
        };
      },
    },
  ];

  const transformAnswersToBody = (context, answers) => {
    const body = {};
    body.coverReason = answers.get("coverReason").value;
    return body;
  };

  const submit = async (context, answers) => {
    return submitCallback({
      shiftId: context.shift.id,
      body: transformAnswersToBody(context, answers),
    });
  };

  return {
    formSequence,
  };
}
